module.exports = __webpack_public_path__ + "static/img/gamebanner3.4136971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/gamebanner3.png
// module id = ZKK5
// module chunks = 0